import { z, ZodType } from "zod";

const phoneValidator: ZodType = z.custom<string>((value): boolean => {
  return !value || new RegExp(/^\+48 [0-9]{3} [0-9]{3} [0-9]{3}$/).test(value);
}, "Błędny numer telefonu");

type phoneValidator = z.infer<typeof phoneValidator>;

export default phoneValidator;
